import { CountdownInterface } from '@/types/aprRankings.types';

export const APR_COUNTDOWN_END_DATE = '2026-10-01T00:00:00Z';

export const PLACEHOLDER_COUNTDOWN: CountdownInterface = {
  days: '--',
  hours: '--',
  minutes: '--',
  seconds: '--',
};

export const FINISHED_COUNTDOWN: CountdownInterface = {
  days: '00',
  hours: '00',
  minutes: '00',
  seconds: '00',
};

export const ACCESS_COOKIE = 'apr-access';
export const ONE_YEAR_IN_SECONDS = 60 * 60 * 24 * 365;
